import { render, staticRenderFns } from "./CheckYourSelf.vue?vue&type=template&id=11233425&scoped=true"
import script from "./CheckYourSelf.vue?vue&type=script&lang=js"
export * from "./CheckYourSelf.vue?vue&type=script&lang=js"
import style0 from "./CheckYourSelf.vue?vue&type=style&index=0&id=11233425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11233425",
  null
  
)

export default component.exports